import { useTheme } from 'styled-components';
import Avatar from '../../components/Avatar';
import { SectionItem } from '../../components/Chrome';
import Grid from '../../components/Grid';
import Tooltip from '../../components/Tooltip';
import { StyledClientIndicator } from './styled';
import { useSyncContext } from '../../contexts/sync';

const ConnectedClients = ({ clients }) => {
  const ws = useSyncContext();
  const theme = useTheme();

  return (
    <SectionItem isPlain={clients} isPadded>
      <Grid gap={theme.space[1]}>
        {clients &&
          clients.map((client) => (
            <Tooltip
              text={ws?.id === client.id ? `${client.name} (you)` : client.name}
              placement="top"
              key={client.id}
            >
              <StyledClientIndicator color={client.color}>
                <Avatar src={client.avatar} isSmall />
              </StyledClientIndicator>
            </Tooltip>
          ))}
      </Grid>
    </SectionItem>
  );
};

export default ConnectedClients;
